import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const ListingChainStatus1 = union([
    literal("no_chain"),
    literal("in_chain"),
    literal("unknown"),
]);
